<template>
    <section id="services">
        <div class="row">
            <div class="py-5 lightBlueBG">
                <div class="container">
                    <div class="row  ">
                        <div class="col-12">
                            <h2 class="mb-4">
                                الخدمات
                            </h2>

                        </div>
                    </div>
                    <div class="row g-4 row-cols-1 row-cols-sm-2 row-cols-lg-6 " id="tab">
                        
                        <div class="col  pointer">
                            <div @click="ToElectronicServices()" class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-laptop"></i>
                                </div>
                                <p>خدمات الالكترونية</p>
                            </div>
                        </div>
                        <div class="col pointer">
                            <div @click="ToTranslatedServices()" class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-language"></i>
                                </div>
                                <p>خدمات الوثائق المترجمة</p>
                            </div>
                        </div>

                        <div class="col pointer">
                            <div @click="ToElectronicServices()"  class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-candy-cane"></i>
                                    <!-- fas fa-wheelchair -->
                                </div>
                                <p>خدمات كبار السن</p>
                            </div>
                        </div>

                        <div class="col pointer">
                            <div @click="ToNews4" class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-headset"></i>
                                </div>
                                <p>خدمات صوتية</p>
                            </div>
                        </div>


                        <div class="col pointer">
                            <div @click="ToInquiry" class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-search"></i>
                                </div>
                                <p>متابعة حالة الطلب</p>
                            </div>
                        </div>
                        <div class="col  pointer">
                            <div @click="ToSoon" class="scal_box rounded darkBlueBG">
                                <div class="icon_holder mb-4 mt-4">
                                    <i class="fas fa-deaf"></i>
                                </div>
                                <p>إرشادات الصم والبكم</p>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ServicesComp',

    methods: {
        ToElectronicServices() {
            this.$router.push({ name: 'electronicservices' })
        },
        ToTranslatedServices() {
            this.$router.push({ name: 'translatedservices' })
        },
        ToIdealCenters() {
            this.$router.push({ name: 'idealcenters' })
        },
        ToNews4() {
            this.$router.push({ name: 'news4' })
        },
        ToInquiry() {
            this.$router.push({ name: 'inquiry' })
        },
        ToSoon() {
            this.$router.push({ name: 'soon' })
        },
    }
}
</script>